import { ICargaPasstModel } from "../interfaces/passt/ICargaPasstModel";

export class CargaPasstModel implements ICargaPasstModel{
    idCargaProgramacionPasst: number;
    anio: number;
    idSede : number;
    idSedeSelected?: number;
    nombreSede : string;
    nombreArchivo: string;
    rutaArchivo: string;
    idEstado: number;
    estado: string;
    detalle: string;
    creadoPor?: string;
    fechaCreacion?: Date;
    idTipoCarga : number;
    idTipoCargaSelected?: number;
    idCompania : number;
    idCompaniaSelected?: number;

    constructor(){
        this.idCargaProgramacionPasst = 0;
        this.anio = 0;
        this.idSede = 0;
        this.nombreSede = '';
        this.nombreArchivo = '';
        this.rutaArchivo = '';
        this.idEstado = 0;
        this.estado = '';
        this.detalle = '';
        this.idTipoCarga = 0;
        this.idCompania = 0;
    }
}